var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* 販売店情報設定(詳細画面) */
import React, { useCallback, useEffect, useState } from 'react';
import { render } from 'react-dom';
import InputText from '../../molecules/maintenance/InputText';
import InputSelect from '../../molecules/maintenance/InputSelect';
import UpdateHistory from '../../molecules/maintenance/UpdateHistory';
import Label from '../../molecules/maintenance/label';
import { select_brand_init, store_params_init } from '../../Const';
import { useToggle } from '../../hooks/ToggleHooks';
import ModalTemplate from '../../molecules/ModalTemplate';
import ModalConfirm from '../../molecules/ModalConfirm';
import LoadingModal from '../../organisms/LoadingModal';
import axios from '../../axios';
import { navigationToStoreLint } from './StoreCommon';
import { useTranslation } from 'react-i18next';
import { getLanguage } from '../../Common';
import { convertUpperCaseAlphaNumericSymbol } from '../../Convert';
var StoreDetail = function () {
    var _a = useToggle(false), is_loading = _a[0], toggleIsLoading = _a[1];
    var _b = useToggle(false), show_update = _b[0], toggleShowUpdate = _b[1];
    var _c = useToggle(false), show_completed = _c[0], toggleShowCompleted = _c[1];
    // 言語
    var _d = useTranslation(), t = _d.t, i18n = _d.i18n;
    useEffect(function () {
        // 言語変更
        i18n.changeLanguage(getLanguage());
    }, []);
    // 販売店情報パラメータの初期化
    var _e = useState(store_params_init), store_params = _e[0], setStoreParams = _e[1];
    /**
     * マスタ情報の更新
     * @return void
     */
    var update = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    toggleIsLoading();
                    toggleShowUpdate();
                    return [4 /*yield*/, axios.put('staff/store/detail/1', { params: store_params })];
                case 1:
                    _a.sent();
                    toggleShowCompleted();
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _a.sent();
                    console.log(error_1);
                    return [3 /*break*/, 4];
                case 3:
                    toggleIsLoading();
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, []);
    /**
     * 店舗情報パラメータの更新
     *
     * @param event
     * @return void
     */
    var handleChangeStoreParams = useCallback(function (event) {
        var _a = event.currentTarget, id = _a.id, value = _a.value;
        setStoreParams(function (prev) {
            var _a;
            return __assign(__assign({}, prev), (_a = {}, _a[id] = value, _a));
        });
    }, [setStoreParams]);
    /**
     * 店舗情報パラメータのフォーカスアウト時
     * 全角英数を半角英数にし、小文字を大文字に変換する
     *
     * @param event
     * @return void
     */
    var handleChangeOnBlur = useCallback(function (event) {
        var _a = event.currentTarget, id = _a.id, value = _a.value;
        var convert_value = convertUpperCaseAlphaNumericSymbol(value);
        setStoreParams(function (prev) {
            var _a;
            return __assign(__assign({}, prev), (_a = {}, _a[id] = convert_value, _a));
        });
    }, [setStoreParams]);
    return (React.createElement("div", null,
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "my-2" },
                React.createElement("div", { className: "col-md-12 col-sm-10" },
                    React.createElement("div", { className: "detaile-header" },
                        React.createElement("button", { className: "btn btn-main-color btn-main-size", disabled: false, onClick: function () { } }, t('戻る')),
                        React.createElement("button", { className: "btn btn-main-color btn-main-size", disabled: false, onClick: toggleShowUpdate }, t('更新実行'))))),
            React.createElement(Label, { title: "" }),
            React.createElement("div", { id: "detail" },
                React.createElement("div", { className: "detail-area" },
                    React.createElement("div", { className: "detail-container" },
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputSelect, { id: "target_brand", title: t('対象ブランド'), class_name: "", value: store_params.target_brand, handleChange: handleChangeStoreParams, options: select_brand_init, help_message: "", valid_message: "", t: t }))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "store_code", title: t('販売店コード'), class_name: "detail-form-input-small", value: store_params.store_code, handleChange: handleChangeStoreParams, help_message: "", valid_message: '', disabled: false, onBlur: handleChangeOnBlur }))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "store_name", title: t('営業グループ'), class_name: "detail-form-input-small", value: '', handleChange: handleChangeStoreParams, help_message: "", valid_message: "", disabled: true }))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "store_name", title: t('担当セールス'), class_name: "detail-form-input-small", value: '', handleChange: handleChangeStoreParams, help_message: "", valid_message: "", disabled: true }))),
                        React.createElement(Label, { title: t('EUC連動情報') }),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "store_name", title: t('小売店名称'), class_name: "detail-form-input-small", value: store_params.store_name, handleChange: handleChangeStoreParams, help_message: "", valid_message: "", disabled: true }))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "post_code", title: t('郵便番号'), class_name: "detail-form-input-small", value: store_params.post_code, handleChange: handleChangeStoreParams, help_message: "", valid_message: "", disabled: true }))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "store_address", title: t('小売店住所'), class_name: "detail-form-input-large", value: store_params.store_address, handleChange: handleChangeStoreParams, help_message: "", valid_message: "", disabled: true }))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "phone_number", title: t('電話番号'), class_name: "detail-form-input-small", value: store_params.phone_number, handleChange: handleChangeStoreParams, help_message: "", valid_message: "", disabled: true }))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "business_category", title: t('業態区分'), class_name: "detail-form-input-small", value: store_params.business_category, handleChange: handleChangeStoreParams, help_message: "", valid_message: "", disabled: true }))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "individual_store_code", title: t('個店コード'), class_name: "detail-form-input-small", value: store_params.individual_store_code, handleChange: handleChangeStoreParams, help_message: "", valid_message: "", disabled: true }))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "individual_store_name", title: t('個店名称'), class_name: "detail-form-input-small", value: store_params.individual_store_name, handleChange: handleChangeStoreParams, help_message: "", valid_message: "", disabled: true }))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "corporation_code", title: t('法人コード'), class_name: "detail-form-input-small", value: store_params.corporation_code, handleChange: handleChangeStoreParams, help_message: "", valid_message: "", disabled: true }))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "corporation_name", title: t('法人名称'), class_name: "detail-form-input-small", value: store_params.corporation_name, handleChange: handleChangeStoreParams, help_message: "", valid_message: "", disabled: true }))),
                        React.createElement(Label, { title: t('ブランド共有情報(屋号)') }),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "official_name", title: t('正式名称'), class_name: "detail-form-input-large", value: store_params.official_name, handleChange: handleChangeStoreParams, help_message: "", valid_message: "", disabled: false }))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "official_post_code", title: t('正式郵便番号'), class_name: "detail-form-input-large", value: store_params.official_post_code, handleChange: handleChangeStoreParams, help_message: "", valid_message: "", disabled: false }))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "official_address", title: t('正式住所'), class_name: "detail-form-input-large", value: store_params.official_address, handleChange: handleChangeStoreParams, help_message: "", valid_message: "", disabled: false }))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "official_phone_number", title: t('正式電話番号'), class_name: "detail-form-input-large", value: store_params.official_phone_number, handleChange: handleChangeStoreParams, help_message: "", valid_message: "", disabled: false }))),
                        React.createElement(UpdateHistory, { history: null, t: t }),
                        React.createElement(Label, { title: t('ブランド別情報') }),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "shop_factor", title: t('ショップ因子(現在)'), class_name: "detail-form-input-smale", value: store_params.shop_factor, handleChange: handleChangeStoreParams, help_message: "", valid_message: "", disabled: false }),
                                React.createElement("button", { className: "btn btn-main-color btn-main-size", disabled: false, onClick: function () { } }, t('因子設定')))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "postcard_input_check_word", title: t('ハガキ入力チェック表示文字'), class_name: "detail-form-input", value: store_params.postcard_input_check_word, handleChange: handleChangeStoreParams, help_message: "", valid_message: "", disabled: false }))),
                        React.createElement("div", { className: "my-2" },
                            React.createElement("div", { className: "col-md-12 col-sm-12" },
                                React.createElement(InputText, { id: "memo", title: t('メモ'), class_name: "detail-form-input", value: store_params.memo, handleChange: handleChangeStoreParams, help_message: "", valid_message: "", disabled: false }))),
                        React.createElement(UpdateHistory, { history: null, t: t }))))),
        React.createElement(ModalTemplate, { show: show_update, ClickCallBackNo: toggleShowUpdate, ClickCallBackYes: update, title: t('確認'), body: t('更新します。よろしいですか？'), t: t }),
        React.createElement(ModalConfirm, { show: show_completed, title: t('完了'), body: t('更新が完了しました。'), clickCallBackConfirm: navigationToStoreLint }),
        React.createElement(LoadingModal, { show: is_loading })));
};
if (document.getElementById('store-detail')) {
    render(React.createElement(StoreDetail, null), document.getElementById('store-detail'));
}
